export const rarityVariables = {
  // Consumer Grade
  '--rarity-consumer-bg':
    'linear-gradient(180deg, rgba(174, 174, 174, 0) 0%, rgba(174, 174, 174, 0.4) 100%)',
  '--rarity-consumer-border': '#AEAEAE',

  // Industrial Grade
  '--rarity-industrial-bg':
    'linear-gradient(180deg, rgba(22, 192, 229, 0) 0%, rgba(22, 192, 229, 0.4) 100%)',
  '--rarity-industrial-border': '#16C0E5',

  // Mil-Spec Grade
  '--rarity-mil-spec-bg':
    'linear-gradient(180deg, rgba(37, 128, 236, 0) 0%, rgba(37, 128, 236, 0.4) 100%)',
  '--rarity-mil-spec-border': '#2580EC',

  // Restricted
  '--rarity-restricted-bg':
    'linear-gradient(180deg, rgba(150, 85, 255, 0) 0%, rgba(150, 85, 255, 0.4) 100%)',
  '--rarity-restricted-border': '#9655FF',

  // Classified
  '--rarity-classified-bg':
    'linear-gradient(180deg, rgba(181, 31, 236, 0) 0%, rgba(181, 31, 236, 0.4) 100%)',
  '--rarity-classified-border': '#B51FEC',

  // Covert
  '--rarity-covert-bg':
    'linear-gradient(180deg, rgba(216, 53, 95, 0) 0%, rgba(216, 53, 95, 0.4) 100%)',
  '--rarity-covert-border': '#D8355F',

  // Rare
  '--rarity-rare-bg':
    'linear-gradient(180deg, rgba(234, 86, 39, 0) 0%, rgba(234, 86, 39, 0.4) 100%)',
  '--rarity-rare-border': '#EA5627',

  // Extraordinary
  '--rarity-extraordinary-bg':
    'linear-gradient(180deg, rgba(230, 211, 41, 0) 0%, rgba(230, 211, 41, 0.4) 100%)',
  '--rarity-extraordinary-border': '#E6D329',

  // Contraband
  '--rarity-contraband-bg':
    'linear-gradient(180deg, rgba(212, 149, 26, 0) 0%, rgba(212, 149, 26, 0.4) 100%)',
  '--rarity-contraband-border': '#D4951A',
}
